import React, { FC } from 'react';

import { AnnouncementBanner } from 'src/apps/mfa/components/announcement-banner/AnnouncementBanner';
import { MfaRouter } from 'src/apps/mfa/router/MfaRouter';
import { useMfaBannerStore } from 'src/apps/mfa/stores/mfaBannerStore';
import { ClarificationBanner } from 'src/common/components/clarification-banner/ClarificationBanner';
import CloseIcon from 'src/common/components/icons/CloseIcon.svg?raw';

import './MfaWrapper.scss';

type MfaWrapperProps = Record<string, never>;

export const MfaWrapper: FC<MfaWrapperProps> = () => {
	const { visible, setVisible } = useMfaBannerStore();

	return (
		<div className="mfa-wrapper">
			{visible && (
				<div className="clarification-banner-wrapper">
					<ClarificationBanner
						hide={() => setVisible(false)}
						dismissIcon={CloseIcon}
						showToggle={false}
					>
						<AnnouncementBanner />
					</ClarificationBanner>
				</div>
			)}

			<MfaRouter />
		</div>
	);
};
